var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 31.3334L39.1667 41.125L29.375 50.9167",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9167 43.0834H66.5833",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.125 7.83337H5.87501C3.71189 7.83337 1.95834 9.58693 1.95834 11.75V82.25C1.95834 84.4132 3.71189 86.1667 5.87501 86.1667H88.125C90.2881 86.1667 92.0417 84.4132 92.0417 82.25V11.75C92.0417 9.58693 90.2881 7.83337 88.125 7.83337Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.25 15.6666H11.75C10.6684 15.6666 9.79166 16.5434 9.79166 17.625V76.375C9.79166 77.4565 10.6684 78.3333 11.75 78.3333H82.25C83.3316 78.3333 84.2083 77.4565 84.2083 76.375V17.625C84.2083 16.5434 83.3316 15.6666 82.25 15.6666Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software-development.c895c170bab616ee0fb08d01342f5c0a.svg";
export { ForwardRef as ReactComponent };